// @ts-nocheck
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductCompareChecked } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import addProductToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/AddProductToCompare";
import removeProductFromCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveProductFromCompare";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import constants from "@store/constants";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { css } from "styled-components";

export interface CompareCheckboxStyles {
    checkbox: CheckboxPresentationProps;
}

export const compareCheckboxStyles: CompareCheckboxStyles = {
    checkbox: {
        css: css`
            ${({ theme }) => css`
                ${theme.checkbox.defaultProps?.css}
                ${spacingStyles(null, theme.design.product.list.contentSpacing)}
            `}
        `,
    },
};
interface Props {
    productContext?: ProductContextModel;
    extendedStyles?: CompareCheckboxStyles;
}

const CompareCheckbox: React.FC<Props> = ({ productContext: productContextFromProps, extendedStyles }) => {
    const styles = useMergeProps(compareCheckboxStyles, extendedStyles);
    const productContextFromHook = useProductContext();
    const productContext = productContextFromProps || productContextFromHook;
    const showCompare = useSettingsCollection().productSettings.enableProductComparisons;
    const toasterContext = useToaster();
    const dispatch = useDispatch();
    const productToCompareLength = useAppSelector(state => state.components.compareProductsDrawer.productsIds.length);

    const productCompareChecked = useSelector((state: ApplicationState) =>
        getProductCompareChecked(state, productContext!),
    );
    if (!productContext || !showCompare) {
        return null;
    }

    const handleChanged = (_: React.SyntheticEvent, value: boolean) => {
        if (value && productToCompareLength >= constants.productCompare.maxNumberOfColumns) {
            toasterContext.addToast({
                body: siteMessage("ProductCompare_MaximumItemsReached"),
                messageType: "warning",
            });
        } else if (value) {
            dispatch(addProductToCompare({ productId: productContext?.product.id || "" }));
        } else {
            dispatch(removeProductFromCompare({ productId: productContext?.product.id || "" }));
        }
    };

    return (
        <Checkbox
            {...styles.checkbox}
            checked={productCompareChecked}
            onChange={handleChanged}
            data-test-selector="productList_CompareCheckbox"
            sizeVariant="small"
        >
            {translate("Compare")}
        </Checkbox>
    );
};

export default CompareCheckbox;
